import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ProductTarifService {

    constructor(
        private http: HttpClient,
        private global: GlobalDataService
    ) { }


    getProductTarif() {
        return this.http.get(this.global.httpUrl + "currencies");
    }

    getProductTarifById(id: any) {
        return this.http.get(this.global.httpUrl + "tariffs/" + id);
    }

    getProductTarifSelectedProducts(id: any) {
        return this.http.get(this.global.httpUrl + "tariffs/products/" + id);
    }

    getProductTarifByTariffNameId(id: any) {
        return this.http.get(this.global.httpUrl + "tariffs?tariff_name_id=" + id);
    }

    createProductTarif(data: any) {
        return this.http.post(this.global.httpUrl + "tariffs", data);
    }

    attachProductTarif(data: any) {
        return this.http.post(this.global.httpUrl + "tariffs/attach-product", data);
    }

    updateProductTarif(data: any, id: any) {
        return this.http.put(this.global.httpUrl + "tariffs/" + id, data);
    }

}




// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/product_tarifs/product-tarif.service.ts